import React, { useContext } from 'react'

import Web3context from '../contexts/Web3context.js'
import abi_1155 from '../contracts/IERC1155Game.json'

const RecipeItem = (props) => {
  if (!props.location.data) {
    window.location = "/recipes"
  }

  const web3context = useContext(Web3context)
  let { getWeb3 } = web3context;

  const bid = async () => {
    try {
      const web3 = getWeb3;
      const item = props.location.data;

      // console.log("Network Id is", await web3.eth.net.getId());
      // const accounts = await web3.eth.getAccounts();
      const contract_1155 = await new web3.eth.Contract(abi_1155.abi, "0xebe32c46234cA88A373a42Ed3916a7222B3E6BB0");

      const info = await contract_1155.methods.getBurnTokensDish(item.id).call();
      console.log(info);
    } catch (err) {
      console.log(err);
    }
  }

  const combine = async () => {
    try {
      const web3 = getWeb3;
      const item = props.location.data;

      const accounts = await web3.eth.getAccounts();
      const contract_1155 = await new web3.eth.Contract(abi_1155.abi, "0xebe32c46234cA88A373a42Ed3916a7222B3E6BB0");
      const ownerAddress = "";
      const txnhash = await contract_1155.methods.cookDish(item.id, ownerAddress, "data")
        .send({ from: accounts[0], gasPrice: "1000000000", gas: 35000 });
      console.log(txnhash);
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <React.Fragment>
      <div className="recipteProducts">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="recipesProduct_img">
                <div className="recipes_img"></div>
                <div className="recipes_items">
                  <ul>
                    <li>RECIPE</li>
                    <li>Cooking Oil</li>
                    <li>Potato</li>
                    <li>Salt</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="recipesProduct_Content">
                <h1>FRENCH FRIES</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="recipesPage unlockThisDish">
        <div className="reciptesTopheading">
          <h2>UNLOCK THIS DISH BY COLLECTING THE INGREDIENTS</h2>
        </div>
        <ul>
          <li>
            <a href="/">
              <div className="recipesCard"></div>
              <p>COOKING OIL</p>
              <button onClick={bid}>bid</button>
            </a>
          </li>

          <li>
            <a href="/">
              <div className="recipesCard"></div>
              <p>SALT</p>
              <button>bid</button>
            </a>
          </li>

          <li>
            <a href="/">
              <div className="recipesCard"></div>
              <p>POTATO</p>
              <button className="bidButton">bid</button>
            </a>
          </li>
        </ul>

        <div className="recipesViewMore">
          <p>COLLECTED THE INGREDIENTS ?
          COMBINE THEM TO MAKE YOUR DISH
            </p>
          <button onClick={combine}>COMBINE</button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default RecipeItem;
